export const mapFillColors = {
  BLUE: '#314053',
  GREEN: '#226622',
  RED: '#882200',
}

export const mapBorderColors = {
  BLACK: '#000',
}

export const mapboxTextColors = {
  WHITE: '#fff',
}

export const mapboxSourceTypes = {
  GEOJSON: 'geojson',
  IMAGE: 'image',
}

export const mapboxLayerTypes = {
  LINE: 'line',
  RASTER: 'raster',
  FILL: 'fill',
  CIRCLE: 'circle',
  SYMBOL: 'symbol',
}

export const mapboxDataTypes = {
  FEATURE_COLLECTION: 'FeatureCollection',
}

export const mapboxFeatureTypes = {
  FEATURE: 'Feature',
}

export const mapboxGeometryTypes = {
  POINT: 'point',
}

export const emptyingIntervalOptions = {
  de: [
    { label: 'Einmalig', value: 'once' },
    { label: 'Wöchentlich', value: '1' },
    { label: 'Alle 2 Wochen', value: '2' },
    { label: 'Alle 3 Wochen', value: '3' },
    { label: 'Alle 4 Wochen', value: '4' },
    { label: 'Alle 5 Wochen', value: '5' },
    { label: 'Alle 6 Wochen', value: '6' },
    { label: 'Alle 7 Wochen', value: '7' },
    { label: 'Alle 8 Wochen', value: '8' },
    { label: 'Alle 9 Wochen', value: '9' },
    { label: 'Alle 10 Wochen', value: '10' },
    { label: 'Alle 11 Wochen', value: '11' },
    { label: 'Alle 12 Wochen', value: '12' },
  ],
  en: [
    { label: 'Once', value: 'once' },
    { label: 'Weekly ', value: '1' },
    { label: 'Every 2 weeks', value: '2' },
    { label: 'Every 3 weeks', value: '3' },
    { label: 'Every 4 weeks', value: '4' },
    { label: 'Every 5 weeks', value: '5' },
    { label: 'Every 6 weeks', value: '6' },
    { label: 'Every 7 weeks', value: '7' },
    { label: 'Every 8 weeks', value: '8' },
    { label: 'Every 9 weeks', value: '9' },
    { label: 'Every 10 weeks', value: '10' },
    { label: 'Every 11 weeks', value: '11' },
    { label: 'Every 12 weeks', value: '12' },
  ],
}

export const weekdayOptions = {
  de: [
    { label: 'Montag', value: 'monday' },
    { label: 'Dienstag', value: 'tuesday' },
    { label: 'Mittwoch', value: 'wednesday' },
    { label: 'Donnerstag', value: 'thursday' },
    { label: 'Freitag', value: 'friday' },
    { label: 'Samstag', value: 'saturday' },
    { label: 'Sonntag', value: 'sunday' },
  ],
  en: [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' },
  ],
}

export const statusColor = {
  commented: '#0969da',
  emptied: '#1c9600',
  pending: '#ffba00',
  skipped: '#dadada',
}
